import { render, staticRenderFns } from "./brand-content-hub-video.vue?vue&type=template&id=daa3c75c"
import script from "./brand-content-hub-video.vue?vue&type=script&lang=js"
export * from "./brand-content-hub-video.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports